import { generate } from 'config/config-generator';
import { stringToObject } from './lib';

const config = generate();
const get = (string) => stringToObject(string, config);

export default {
  get,
};
